import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

class PersonConsented extends Component {
  render() {
    return (

        <Row>
          <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
            <h2>
                De aanmelding is al bevestigd.
            </h2>

            <p>
              Heb je nog vragen? Neem dan contact op met vereniging {this.props.clubName}.
            </p>

          </Col>
        </Row>
   );
 }
}

export default PersonConsented



// WEBPACK FOOTER //
// ./src/personconsent/PersonConsented.jsx